import { useNaviAc } from "@/hooks/useNavi";
import useTranslation from "@/hooks/useTranslation";
import { SearchParams } from "@/interfaces/pubmed.interface";
import { sideBarState } from "@/stores/common";
import { naviMergedField } from "@/stores/navi";
import { TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import SearchSharpIcon from "@material-ui/icons/SearchSharp";
import SettingsSharpIcon from "@material-ui/icons/SettingsSharp";
import { AutoComplete, Drawer } from "antd";
import React, { useState } from "react";
import { useRecoilState } from "recoil";
import SideBar from "../SideBar";
import styles from "./styles.module.less";

const { container, button, wrapper, lgUp } = styles;

export interface TopBarProps {
  loadingSearch?: boolean;
  correctedQuery?: string;
  handleSearch: (term: string) => void;
}

const TopBar: React.FC<TopBarProps> = (props) => {
  const [{ term }] = useRecoilState<Partial<SearchParams>>(
    naviMergedField("searchParams")
  );

  const { suggestTerms, suggestedTerms } = useNaviAc();

  const { loadingSearch = false, handleSearch } = props;

  const [{ sideBar }, setSideBar] = useRecoilState(sideBarState);

  const { t } = useTranslation("explore");

  const [lTerm, setLTerm] = useState(term);

  const [open, setOpen] = useState(false);

  return (
    <>
      <div className={container}>
        <form noValidate autoComplete="off">
          <AutoComplete
            options={suggestedTerms}
            open={open}
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
            allowClear
            value={lTerm}
            onChange={(value: string) => {
              setLTerm(value);
              suggestTerms(value);
            }}
          >
            <TextField multiline label={t("navi.topbar.label")} required />
          </AutoComplete>
        </form>
        <div className={button}>
          <div className={wrapper}>
            <Button
              endIcon={<SearchSharpIcon />}
              variant="outlined"
              color="primary"
              onClick={() => handleSearch(lTerm)}
              disabled={loadingSearch}
            >
              {t("navi.topbar.search")}
            </Button>
          </div>
          <div className={wrapper}>
            <Button
              variant="contained"
              color="primary"
              endIcon={<SettingsSharpIcon />}
              onClick={() => setSideBar({ sideBar: true })}
              className={lgUp}
            >
              {t("navi.topbar.settings")}
            </Button>
          </div>
        </div>
      </div>
      <Drawer
        title={t("navi.topbar.settings")}
        placement="left"
        closable
        onClose={() => setSideBar({ sideBar: false })}
        visible={sideBar}
        width={275}
      >
        <SideBar />
      </Drawer>
    </>
  );
};

export default TopBar;
